//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { RightsRequestCommunicationType } from '@apis/rights-management/rightsManagementApiModels';
import PartialCuid from '@models/PartialCuid';
import { RIGHTS_REQUEST_EXTERNAL_APPROVAL_COMMUNICATION_TYPES } from '@uia/rights/constants/uiaRightsConstants';
import { useGraphRightsCapabilityQuery } from '@uia/rights/hooks/useGraphRightsCapabilityQuery';
import { isDefined } from '@utils/filterPredicates';

import { RIGHTS_STATUS } from 'app/bulk-actions/bulk-actions-constants/bulk-actions-constants';

export const useShouldShowCopyRightsFlowQuery = (
  partialCuid: PartialCuid,
  status?: RIGHTS_STATUS,
  communicationType?: RightsRequestCommunicationType,
) => {
  const hasExternalRightsApproval =
    isDefined(communicationType) &&
    RIGHTS_REQUEST_EXTERNAL_APPROVAL_COMMUNICATION_TYPES.includes(
      communicationType,
    ) &&
    status === RIGHTS_STATUS.APPROVED;

  return useGraphRightsCapabilityQuery(
    partialCuid,
    (isCapable) => !isCapable && !hasExternalRightsApproval,
    isDefined(status),
  );
};
